import React, { useEffect, useState } from 'react';
import { Popover } from 'onefaceui-react-components';
import PropTypes from 'prop-types';
import FilterEquipmentVisibilityPopoverContent from './FilterEquipmentVisibilityPopoverContent';
import { FILTER_EQUIPMENT_VISIBILITY_DEFAULT } from '../constants';

function FilterEquipmentVisibilityPopover({
  isOpen = false,
  onOpenChange = () => {}
}) {
  const [selectedOption, setSelectedOption] = useState(FILTER_EQUIPMENT_VISIBILITY_DEFAULT);
  useEffect(() => {
    const storage = new Greenmile.Storage.StoreMapPosition();
    const stored = storage.getEquipmentVisibilityFilterOption();
    if (stored !== selectedOption) {
      setSelectedOption(stored);
    }
  }, [isOpen]);

  const handleOptionChange = ({ target: { value } }) => {
    const storage = new Greenmile.Storage.StoreMapPosition();
    storage.setEquipmentVisibilityFilterOption(value);
    App.Objects.RouteMonitor.getEquipmentPositionsByOrganizations();
    setSelectedOption(value);
  };

  return (
    <Popover
      content={(
        <FilterEquipmentVisibilityPopoverContent
          defaultChecked={selectedOption}
          onOptionChange={handleOptionChange}
        />
      )}
      side="top"
      align="center"
      open={isOpen}
      onOpenChange={onOpenChange}
      dataTestId="filterEquipmentsTooltip"
    >
      <button
        className={`filterEquipment ${isOpen ? 'checked' : ''}`}
        type="button"
      />
    </Popover>
  );
}

FilterEquipmentVisibilityPopover.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired
};

export default FilterEquipmentVisibilityPopover;
